import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLocations } from '../../store/actions';
import useLocations from './use-locations';

export const useFetchLocation = () => {
  const dispatch = useDispatch();
  const tournamentId = useSelector(authStoreUserTournamentId);
  const { isLoading, isLoaded, locations, tournamentId: tournamentIdFromLocations } = useLocations();

  useEffect(() => {
    if (tournamentId && tournamentId !== tournamentIdFromLocations) {
      dispatch(fetchLocations({ tournamentId }));
    }
  }, [dispatch, isLoaded, isLoading, tournamentId, tournamentIdFromLocations]);

  return {
    isLoading,
    isLoaded,
    locations,
  };
};
